// Centralized API configuration
// Automatically detects production vs development environment
import axios from 'axios';

export const getApiUrl = () => {
  // If we're on a custom domain (not localhost and not emergentagent preview), use current origin
  const hostname = window.location.hostname;
  const isProduction = hostname !== 'localhost' && 
                       hostname !== '127.0.0.1' &&
                       !hostname.includes('preview.emergentagent.com');
  
  if (isProduction) {
    // In production with custom domain, API is on same origin
    return window.location.origin + '/api';
  }
  
  // In development/preview, use the env variable or fallback to origin
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    return backendUrl + '/api';
  }
  
  return window.location.origin + '/api';
};

export const API = getApiUrl();
// BACKEND_URL is the absolute origin to prepend to backend-relative paths
// (e.g. `${BACKEND_URL}${replay.video_url}` for <video src>).
//
// MUST follow the same production-vs-preview logic as `API` — otherwise
// in production with a custom domain the <video> element ends up loading
// `https://<emergent-host>/api/replay/file/...` which is CROSS-ORIGIN to
// the page on https://datapro.ar/. Browsers (and Cloudflare's bot-fight
// rules sitting in front of *.emergent.host) reject those requests with
// CORS errors and 400 Bad Request, because the <video> tag's headers
// (Range + Accept-Encoding: identity + no _cf_bm cookie) look like a
// scraper to the edge.
//
// Returning `window.location.origin` in production keeps every API
// request — including <video> streaming — same-origin, transparent
// to whichever custom domain the customer points at the app.
export const BACKEND_URL = (() => {
  const hostname = (typeof window !== 'undefined') ? window.location.hostname : '';
  const isProduction = hostname && hostname !== 'localhost'
    && hostname !== '127.0.0.1'
    && !hostname.includes('preview.emergentagent.com');
  if (isProduction) return window.location.origin;
  return process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : '');
})();

// Send withCredentials by default so the session cookie travels on every request
axios.defaults.withCredentials = true;

// Authorization header fallback: many browsers block third-party cookies on
// custom domains. We persist the session token in localStorage at login time
// and inject it as a Bearer token, which the backend also accepts (see
// `get_current_user` in /app/backend/auth.py).
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('datapro_session_token');
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

